import { SmsBundleTierSelectWidgetContent } from './SmsBundleTierSelectWidgetContent';
import type { AddOnsWidgetProps } from './useAddOnsWidget';
import { WithStatusHandling } from '../WithStatusHandling';

type Props = AddOnsWidgetProps & { inConfiguratorRow?: boolean };

export const SmsBundleTierSelectWidget = ({ status, handlers, data, hooks, inConfiguratorRow }: Props) => {
  return (
    <WithStatusHandling
      skeletonHeight={46}
      status={status}
      errorMessage={status === 'error' ? data.error?.message : undefined}
      retry={status === 'error' ? handlers.retry : undefined}
    >
      {status === 'loaded' && data.getIsSmsBundle() && (
        <SmsBundleTierSelectWidgetContent
          data={data}
          handlers={handlers}
          hooks={hooks}
          inConfiguratorRow={inConfiguratorRow}
          isDisabled={'getIsSingleBillChildAccount' in data && data.getIsSingleBillChildAccount()}
        />
      )}
    </WithStatusHandling>
  );
};
